import React from "react";

import { css, cx } from "@emotion/css";
import { type Table as TSTable } from "@tanstack/react-table";

import { useStyles } from "@/hooks/useStyles.ts";
import type { LibreViewClinicPatient } from "@/models/LibreViewModel.ts";
import { Theme } from "@/theme/CreateTheme.ts";
import { MuiTable } from "@/uiKit/Table.tsx";

export type LibreviewGroupedInclusionTableProps = {
  table: TSTable<LibreViewClinicPatient>;
  className?: string;
};

export const LibreviewGroupedInclusionTable: React.FC<LibreviewGroupedInclusionTableProps> = ({ table, className }) => {
  const styles = useStyles(makeStyles);

  return (
    <div className={cx(styles.container, className)}>
      <MuiTable id="libreview-grouped-inclusion-table" table={table} classes={{ headerCell: styles.headerCell }} />
    </div>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css({}),
  headerCell: css({
    backgroundColor: theme.palette.grey[200],
    borderBottom: `1px solid ${theme.palette.divider}`,
  }),
});
